import { useEffect, useState } from "react";
import { usePopupController } from "../lib/usePopupController";

export function useScrollSalesPopup() {
  // ✅ Reset dismiss state on every full page load
  useEffect(() => {
    // console.log("🔁 Resetting popup dismissal state on load");
    sessionStorage.setItem("kohbergerDismissCount", "0");
    localStorage.removeItem("kohbergerPopupDismissed");
  }, []);

  const { requestShow, dismissPopup } = usePopupController();

  // ✅ Safe initialization — read from storage once
  const [dismissCount, setDismissCount] = useState(() => {
    const saved = sessionStorage.getItem("kohbergerDismissCount");
    return saved ? parseInt(saved, 10) : 0;
  });

  const [show, setShow] = useState(false);

  // ✅ Clean logic: track 2 sections
  const sections = ["BBFIntro", "BBFNoThereThere"];
  const targetSection = sections[dismissCount];

  useEffect(() => {
    if (
      show ||
      !targetSection ||
      localStorage.getItem("kohbergerPopupDismissed") === "true"
    ) return;

    const timeout = setTimeout(() => {
      const element = document.getElementById(targetSection);
      if (!element) {
        return;
      }

      let triggered = false;
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !triggered) {
              triggered = true;
              requestShow("kohberger", false);
              setShow(true);
              obs.disconnect();
            }
          });
        },
        { threshold: 0.5 }
      );

      observer.observe(element);
    }, 50); // ⏱ Delay guarantees DOM is ready

    return () => clearTimeout(timeout);
  }, [targetSection, show]);


  const handleClose = () => {
    if (dismissCount < 2) {
      const newCount = dismissCount + 1;
      setDismissCount(newCount);
      sessionStorage.setItem("kohbergerDismissCount", String(newCount));

      if (newCount >= 2) {
        localStorage.setItem("kohbergerPopupDismissed", "true");
      }
    }

    setShow(false);
    dismissPopup("kohberger");
  };


  return { show, setShow: handleClose };
}
